module.exports = __webpack_public_path__ + "img/blog-6.3abfd069.jpg";